<section fxLayout="row">
  <div fxLayout="column" class="tasktab">
    <p class="taskText">{{'COMPONENTS.HANDOVERPOINTS.TEXT' | i18next }}</p>

    <!--
    <button *ngIf="!onboardingComp.handsoverDone; else elseBlock" (click)="onboardingComp.handsoverDone = true" class="doneButton">{{'COMMON.DONE' | i18next }}</button>
    -->

    <ng-template #elseBlock >
    </ng-template>
  </div>
</section>
